class NodeHandler{
    constructor(node, args){
        this.node = node
        node.__handler = this
        this.args = args
        this.dom = {}
        this.events = {}
        this.__collect_dom()
        this.__before_init()
        this.__init()
    }
    __before_init(){}
    // __init(){}
    __init_dom_schema(){
        return {}
    }
    __collect_dom(){
        const schema = this.__init_dom_schema()
        
        for(const [key, config] of Object.entries(schema)){
            this.__init_dom(key, config)
        }
    }
    __init_dom(key, config){
        let is_single = true
        let selector = '_____'
        let actions = null

        if (typeof config == 'object'){
            selector = config.selector
            is_single = config?.is_single ?? true
            actions = config?.actions || null
        }else{
            selector = config
        }

        let dom

        if(key == '__node__'){
            dom = this.node
        }

        if(!dom){
            dom = is_single 
                ? this.node.querySelector(selector) 
                : this.node.querySelectorAll(selector)
        }

        if(actions){
            this.__init_dom_actions(dom, actions)
        }

        this.dom[key] = dom
    }
    __init_dom_actions(dom, actions){
        
        for(const [events_string, callback] of Object.entries(actions)){
            const events = events_string.split('|')
            for(const event_name of events){
                if(dom instanceof NodeList){
                    for(const dom_ of dom){
                        dom_.addEventListener(event_name, callback)
                    }
                }else{
                    dom.addEventListener(event_name, callback)
                }
            }
        }
    }
}


class NodeEvent{
    constructor(name){
        this.name = name;
        this.callbacks = [];
    }
    registerCallback(callback){
        this.callbacks.push(callback);
    }
}

function getWords(string){
    let w = string.replace(/[\,\s\|]+/, ' ').split(' ');
    return w;
}

NodeHandler.prototype.registerEvents = function(...events){
    for(const eventObject of events){
        for(const eventName of getWords(eventObject)){
            this.events[eventName] = new NodeEvent(eventName);
        }
    }
};

NodeHandler.prototype.dispatchEvent = function(eventName, eventArgs){
    this.events[eventName].callbacks.forEach(function(callback){
        callback(eventArgs);
    });
};

NodeHandler.prototype.addEventListener = function(events, callback){
    // console.log(this)
    for(const eventName of getWords(events)){
        this.events[eventName].registerCallback(callback);
    }
};

export default NodeHandler